/**
 * Products as Variants - AJAX Product Switching
 * Handles switching between products without page reload
 */

(function () {
    'use strict';

    function syncGokwikButtonState() {
        const addToCartButton = document.querySelector("button[name='add']");
        const gokwikBuyNowButton = document.getElementById('gokwik-buy-now');

        if (gokwikBuyNowButton) {
            const shouldDisable = Boolean(addToCartButton && addToCartButton.disabled);

            if (shouldDisable) {
                gokwikBuyNowButton.setAttribute('disabled', 'disabled');
                gokwikBuyNowButton.classList.add('disabled');
            } else {
                gokwikBuyNowButton.removeAttribute('disabled');
                gokwikBuyNowButton.classList.remove('disabled');
            }
        }

        const gokwikCheckoutButtons = document.querySelectorAll('.gokwik-checkout button');
        gokwikCheckoutButtons.forEach((button) => {
            if (button.disabled) {
                return;
            }
            button.classList.remove('disabled');
        });
    }

    function initProductsAsVariants() {
        const variantItems = document.querySelectorAll('.product-variant-item');

        if (!variantItems.length) return;

        variantItems.forEach(item => {
            const link = item.querySelector('.product-variant-link');
            const tooltip = item.querySelector('.product-variant-tooltip');

            if (!link) return;

            // Prevent double-binding
            if (link.dataset.productsAsVariantsInit === 'true') return;
            link.dataset.productsAsVariantsInit = 'true';

            // Position tooltip on hover
            if (tooltip) {
                item.addEventListener('mouseenter', function () {
                    const rect = item.getBoundingClientRect();
                    const tooltipRect = tooltip.getBoundingClientRect();

                    // Position below the item
                    tooltip.style.left = (rect.left + rect.width / 2) + 'px';
                    tooltip.style.top = (rect.bottom + 8) + 'px';
                    tooltip.style.transform = 'translateX(-50%)';
                });
            }

            link.addEventListener('click', function (e) {
                e.preventDefault();

                // Check if sold out
                const isSoldOut = this.dataset.soldout === 'true';
                if (isSoldOut) {
                    alert('This product is currently sold out.');
                    return;
                }

                // Check if already active
                if (item.classList.contains('is-active')) {
                    return;
                }

                const productUrl = this.dataset.productUrl;
                if (!productUrl) return;

                // Update active state immediately for better UX
                updateActiveState(item);

                // Load product via AJAX
                loadProductContent(productUrl);
            });
        });
    }

    function updateActiveState(newActiveItem) {
        // Remove active class from all items
        document.querySelectorAll('.product-variant-item.is-active').forEach(item => {
            item.classList.remove('is-active');
        });

        // Add active class to clicked item
        newActiveItem.classList.add('is-active');
    }

    function loadProductContent(url) {
        // Show loading state
        const mainContent = document.querySelector('.productView');
        if (mainContent) {
            mainContent.style.opacity = '0.5';
            mainContent.style.pointerEvents = 'none';
        }

        // Fetch the product page
        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Update product images
                const newImages = doc.querySelector('.productView-images');
                const currentImages = document.querySelector('.productView-images');
                if (newImages && currentImages) {
                    currentImages.innerHTML = newImages.innerHTML;
                }

                // Update product info (title, price, description, etc.)
                const newInfo = doc.querySelector('.productView-details');
                const currentInfo = document.querySelector('.productView-details');
                if (newInfo && currentInfo) {
                    currentInfo.innerHTML = newInfo.innerHTML;
                }

                // Update product form
                const newForm = doc.querySelector('form[action*="/cart/add"]');
                const currentForm = document.querySelector('form[action*="/cart/add"]');
                if (newForm && currentForm) {
                    currentForm.innerHTML = newForm.innerHTML;
                }

                // Update URL without reload
                window.history.pushState({}, '', url);

                // Reinitialize any scripts that need to run on the new content
                reinitializeScripts();
                initProductsAsVariants(); // Re-attach listeners to new elements
                syncGokwikButtonState();
                setTimeout(syncGokwikButtonState, 350);

                // Remove loading state
                if (mainContent) {
                    mainContent.style.opacity = '1';
                    mainContent.style.pointerEvents = 'auto';
                }
            })
            .catch(error => {
                console.error('Error loading product:', error);
                // Fallback to regular navigation
                window.location.href = url;
            });
    }

    function reinitializeScripts() {
        // Reinitialize variant selectors if they exist
        if (typeof window.VariantSelects !== 'undefined') {
            const variantSelects = document.querySelectorAll('variant-selects');
            variantSelects.forEach(select => {
                if (select.connectedCallback) {
                    select.connectedCallback();
                }
            });
        }

        // Reinitialize variant radios if they exist
        if (typeof window.VariantRadios !== 'undefined') {
            const variantRadios = document.querySelectorAll('variant-radios');
            variantRadios.forEach(radio => {
                if (radio.connectedCallback) {
                    radio.connectedCallback();
                }
            });
        }

        // Reinitialize image galleries/sliders
        if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
            // Trigger theme-specific reinitialization
            document.dispatchEvent(new CustomEvent('product:loaded'));
        }
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initProductsAsVariants();
            syncGokwikButtonState();
        });
    } else {
        initProductsAsVariants();
        syncGokwikButtonState();
    }

    // Reinitialize when section is reloaded in theme editor
    document.addEventListener('shopify:section:load', function (event) {
        initProductsAsVariants();
        syncGokwikButtonState();
    });

})();
